export default ({ hotelId }) => ({
    hotelId,
});